module.exports = __webpack_public_path__ + "img/chinesecompany107.8e883522.png";